export function weaponMinMax({ level, quality }: { level: number; quality: number }): [number, number] {
  const minDamage = ((quality * (quality + 1)) / 2 + quality) * 1 + level * 4;
  // TODO: Eventually we will have bonuses which add arbitrary amounts to max damage
  return [minDamage, minDamage + 4];
}
